<template>
  <section class="detail-discount-card-info">
    <div class="detail-discount-card-info__row">
      <p>Текущий уровень скидки:</p>
      <p class="detail-discount-card-info__value actual-percentage">
        {{ detailDiscountCard.getCurrentDiscountPercent() }}
      </p>
    </div>
    <div class="detail-discount-card-info__row">
      <p>До следующего уровня:</p>
      <the-rub
        currency="тнг"
        v-bind:kop="detailDiscountCard.getAmountToNextLevel()"
        v-bind:show-kop="$options.SHOW_KOP_AUTO"
      />
    </div>
  </section>
</template>

<script>
import { DetailDiscountCard } from '@/mixins/loyaltySystemMixin';
import TheRub, { SHOW_KOP_AUTO } from './TheRub.vue';

export default {
  /**
   * @description Компонент информации о скидочной карте
   */
  name: 'DetailDiscountCardInfo',
  SHOW_KOP_AUTO,
  components: { TheRub },
  props: {
    /**
     * @description Детализированная скидочная карта
     * @type {DetailDiscountCard}
     */
    detailDiscountCard: {
      type: DetailDiscountCard,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.detail-discount-card-info {
  display: grid;
  gap: 12px;
  font-size: 16px;

  &__row {
    display: grid;
    grid-template-columns: 200px minmax(100px, 250px);
    gap: 10px;
  }

  &__value {
    gap: 0;

    &.actual-percentage::after {
      content: '%';
    }

    &.needed-money::after {
      content: 'т';
    }
  }
}
</style>
